export default "__VITE_PUBLIC_ASSET__ffef7837__"